import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import classNames from 'classnames';

class CustomPagination extends React.PureComponent {
    onClickPrev = () => {
        const { current, onChange } = this.props;
        if (current - 1 > 0) {
            onChange(current - 1);
        }
    };

    onClickNext = () => {
        const { next_disabled, current, onChange } = this.props;
        if (!next_disabled && current) {
            onChange(current + 1);
        }
    };

    render() {
        const { position, size, next_disabled, current } = this.props;
        return (
            <div className={classNames("ori-tb-pad-15 ori-flex-row ", { "ori-flex-jc": position === 'center', "ori-flex-jfe": position === 'right' })}>
                <ul className={classNames("ant-pagination ", { "mini": size === 'small' })}>
                    <li className={classNames("ori-lr-pad-5 ant-pagination-prev", { "ant-pagination-disabled ori-font-light": current === 1 })} onClick={this.onClickPrev}>
                        <Icon type="left" />
                    </li>
                    {
                        current >= 2 &&
                        <li className="ant-pagination-item" onClick={this.onClickPrev}>{current - 1}</li>
                    }
                    <li className="ant-pagination-item ant-pagination-item-active">{current}</li>
                    {
                        !next_disabled &&
                        <li className="ant-pagination-item" onClick={this.onClickNext}>{current + 1}</li>
                    }
                    <li className={classNames("ori-lr-pad-5 ant-pagination-next", { "ant-pagination-disabled ori-font-light": next_disabled })} onClick={this.onClickNext}>
                        <Icon type="right" />
                    </li>
                </ul>
            </div>
        );
    }
}

CustomPagination.propTypes = {
    current: PropTypes.number.isRequired,
    position: PropTypes.string,
    size: PropTypes.string,
    next_disabled: PropTypes.bool,
    onChange: PropTypes.func,
};

CustomPagination.defaultProps = {
    current: 1,
    position: 'right',
    next_disabled: false,
};

export default CustomPagination;


// WEBPACK FOOTER //
// ./src/components/custompagination/index.js